import { Mixins, Component } from "vue-property-decorator";
import { CommitableDataSlidePanel } from "@/components/slide-panel";
import DateInput from "@/components/date-input";
import XTextarea from '@/components/x-textarea';
import { Getter } from 'vuex-class';
import CavCusActionEntreprise from '@/lib/models/cav-cus-action-entreprise';
import { notEmpty } from '@/lib/helpers';

@Component
export default class PanelCusActionEntreprise extends Mixins<CommitableDataSlidePanel<CavCusActionEntreprise>>(CommitableDataSlidePanel) {

  @Getter getLexique;

  async created() {
    this.create && (this.data = new CavCusActionEntreprise());
    this.validators = [
      {fn: d => notEmpty(d.dateAction), message: "La date est requise"},
      {fn: d => notEmpty(d.description), message: "La description de l'action est requise"}
    ];
  }

  mounted() {}

  renderHead() {
    return <span>Action entreprise</span>
  }

  renderBody() {
    if (!this.data) return null;
    return (
      <div class="basic">
        <div class="field">
          <label class="label is-small">Date (*)</label>
          <div class="control">
            <DateInput v-model={this.data.dateAction} />
          </div>
        </div>
        <div class="field">
          <label class="label is-small">Action (*)</label>
          <div class="control">
            <XTextarea vModel={this.data.description} class="textarea is-small" rows={2}/>
          </div>
        </div>
      </div>
    );
  }
  
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-18d8e58e/panel-action-entreprise.tsx" });